import {Injectable} from '@angular/core';
import {ActionSheet, ActionSheetController, AlertController, Platform} from 'ionic-angular';

/**
 * Default wrapper for an action sheet
 * @class
 * @abstract
 */
@Injectable()
export abstract class AbstractActionSheet {
  /**
   * the action sheet
   * @protected
   * @type {ActionSheet}
   */
  actionSheet: ActionSheet;

  /**
   * @constructor
   * @param {ActionSheetController} actionSheetCtrl - Instance of the ActionSheetController class
   * @param {Platform} platform - Instance of the Platform class
   * @param {AlertController} alertCtrl - Instance of the AlertController class
   */
  constructor(public actionSheetCtrl: ActionSheetController,
    public platform: Platform,
    public alertCtrl: AlertController) {
  }

  /**
   * Presents the action sheet
   * @param {object} opts Options for the action sheet
   * @param {status} status of the content
   * @returns {Promise<any>}
   */
  present(opts: object, status: string = null): ActionSheet {
    this.actionSheet = this.actionSheetCtrl.create(opts);

    this.actionSheet.present();
    return this.actionSheet;
  }

  /**
   * Dismisses the action sheet
   * @returns {Promise<any>}
   */
  dismiss(): Promise<any> {
    return this.actionSheet.dismiss();
  }

  /**
   * Checks to see if the platform is iOS. We don't show icons in iOS action sheets.
   * @protected
   * @param {string} icon icon to show
   * @returns {string}
   */
  protected checkIconForIos(icon: string): string {
    return !this.platform.is('ios') ? icon : null;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/action-sheet/abstract/abstract-action-sheet.component.ts